import { Theme } from "../../../components/constants" 

export default {
    passwordForm:{
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        width: "100%",
    },
    marginTop: {
        marginTop: "30px",
    },
    errorMessage: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.ERROR_TEXT,
    },
    messageSuccess: {
        color: Theme.SUCCESS,
    },
    resetButtonDiv: {
        width: "100%",
        marginTop: "40px",
    },
    signInOptionContainer: {
        display: "flex",
        flexDirection: "row",
        marginTop: "10px",
        fontSize: "14px",
    },
    separatorDiv: {
        marginTop: "20px",
    },
    signUpLink: {
        marginLeft: "6px",
    },
    errorMessageContainer: {
        minHeight: "22px",
        marginTop: "20px",
    },
    forgotPasswordLink: {
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "18px",
        color: Theme.PRIMARY,
    },
    signInLink: {
        marginLeft: "6px",
    },
    
}